<template>
	<div class="commission-page">
		<section class="sec-10">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.personal_commission_page_v2.sec_10.title.one') }}
					<strong>
						{{ $t('new_ui.personal_commission_page_v2.sec_10.title.two') }}
					</strong>
				</h2>
				<p>
					{{ $t('new_ui.personal_commission_page_v2.sec_10.desc.one') }}
				</p>
				<div class="btn-box">
					<a href="/auth/register" class="btn-type-01">
						{{ $t('new_ui.personal_commission_page_v2.sec_10.btn.one') }}
					</a>
					<a
						href="javascript:void(0)"
						@click="showComingSoon"
						class="btn-type-02"
					>
						{{ $t('new_ui.personal_commission_page_v2.sec_10.btn.two') }}
					</a>
				</div>
				<div class="img-box">
					<img v-if="!isMobile" :src="img.imgCommissionSec10" alt="" />
					<img v-if="isMobile" :src="img.imgCommissionSec10M" alt="" />
				</div>
			</div>
		</section>
		<section class="sec-11">
			<div class="container-box">
				<div class="content-box content-01">
					<h3>
						{{ $t('new_ui.personal_commission_page_v2.sec_11.one.title.one')
						}}<br />
						{{ $t('new_ui.personal_commission_page_v2.sec_11.one.title.two') }}
					</h3>
					<p>
						{{ $t('new_ui.personal_commission_page_v2.sec_11.one.desc.one') }}
					</p>
				</div>
				<div class="content-box content-02">
					<h3>
						{{ $t('new_ui.personal_commission_page_v2.sec_11.two.title.one') }}
					</h3>
					<p>
						{{ $t('new_ui.personal_commission_page_v2.sec_11.two.desc.one') }}
					</p>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import imgCommissionSec10 from '@/assets/images/v2/img-commission-sec-10.png';
import imgCommissionSec10M from '@/assets/images/v2/img-commission-sec-10-m.png';

export default {
	data: () => {
		return {
			mobile: false,
			img: {
				imgCommissionSec10,
				imgCommissionSec10M,
			},
		};
	},
	computed: {
		isMobile() {
			return this.mobile;
		},
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		checkMobile() {
			this.mobile = window.innerWidth <= 768;
		},
		showComingSoon() {
			alert('Coming soon.');
		},
	},
};
</script>
